import React from "react";
import TableHeader from "../components/TableHeader";


function MainView() {
  return (
    <div className="w-full h-full bg-[rgb(242,243,247)] py-16 px-20">
      <div className="h-full w-full bg-white rounded-[6px]">
        <TableHeader/>
        <div>
          <div>
            
          </div>
        </div>
      </div>
    </div>
  );
}

export default MainView;
